// React imports.
import React, { Component,   } from "react";

// App imports.
import StartPage from "./StartPage";
import SelectStateAndYear from "./SelectStateAndYear";
import StartNewAssessment from "./StartNewAssessment";
import Assessment1 from "./Assessment1";
import Assessment2a from "./Assessment2a";
import Assessment2b from "./Assessment2b";
import Assessment3a from "./Assessment3a";
import Assessment3b from "./Assessment3b";
import Assessment4 from "./Assessment4";
import OverallAssessment from "./OverallAssessment";

import {AppPagesEnum} from "../state";

import { createState } from "../state";
//import spinnerImage from "../../images/spinner-small.gif";


class BaseLayout extends Component {
    state = createState(this);

    //handleScroll = () => {
    //    window.scrollTo(0, 0);
    //};

    //componentDidMount = () => this.handleScroll()

    //componentDidUpdate = () => this.handleScroll()

    /**
     * Render().
     */
    render() {
        return (
          <div className="appContainer">
                <h1>LIHEAP Data Reliability Assessment Tool - Electric Baseload Expenditures</h1>
                {/*----------------------------
                 * Display error message
                 * ----------------------------*/}
                {this.state.ShowSpinner == true
                  && <img src="/data_warehouse/images/spinner-small.gif" alt="Image to show that page is loading" className="spinner" style={{ padding: 20, }} />
                }
                {(this.state.ErrorMessage !== '')
                  && <span className="errorMessageText">
                        <br/><br/>{this.state.ErrorMessage}<br/><br/>
                      </span>}
                {/*----------------------------*/}  

                <div  className="innerPageDivs">
                    <div className="pseudo-accordion " >
                        <h2>{this.state.MainHeader}</h2>

                        { (this.state.SelectedYear != null
                          && this.state.SelectedGranteeId != null
                          && this.state.CurrentAppPage !==  AppPagesEnum.StartPage
                          && this.state.CurrentAppPage !==  AppPagesEnum.StartNewAssessment
                          && this.state.CurrentAppPage !==  AppPagesEnum.SelectStateAndYear)
                        &&<h3>{this.state.SelectedGranteeName},  {this.state.SelectedYear}</h3>
                        }

                        {this.state.CurrentAppPage ===  AppPagesEnum.StartPage
                            && <StartPage state={this.state} />}
                        {this.state.CurrentAppPage ===  AppPagesEnum.StartNewAssessment
                            && <StartNewAssessment state={this.state} />}
                        {this.state.CurrentAppPage ===  AppPagesEnum.SelectStateAndYear
                            && <SelectStateAndYear state={this.state} />}
                        {this.state.CurrentAppPage ===  AppPagesEnum.Assessment1
                            && <Assessment1 state={this.state} />}
                        {this.state.CurrentAppPage ===  AppPagesEnum.Assessment2a
                            && <Assessment2a state={this.state} />}
                        {this.state.CurrentAppPage ===  AppPagesEnum.Assessment2b
                            && <Assessment2b state={this.state} />}
                        {this.state.CurrentAppPage ===  AppPagesEnum.Assessment3a
                            && <Assessment3a state={this.state} />}
                        {this.state.CurrentAppPage ===  AppPagesEnum.Assessment3b
                            && <Assessment3b state={this.state} />}
                        {this.state.CurrentAppPage ===  AppPagesEnum.Assessment4
                            && <Assessment4 state={this.state} />}
                        {this.state.CurrentAppPage ===  AppPagesEnum.OverallAssessment
                            && <OverallAssessment state={this.state} />}
                    </div>
                </div>
          </div>
        );
    }

}
export default BaseLayout;
